import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, ViewChild, WritableSignal, computed, effect, signal } from '@angular/core';
import { CommonModule } from "@angular/common";

import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule} from "@angular/material/menu";
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';

import { PageComponent } from "../../../layout/pages/page/page.component";
import { MyButtonComponent } from "../../../shared/components/buttons/my-button/my-button.component";
import { DialogService } from "../../../core/services/dialog.service";

import { DatiPrelievo}  from "../models/dati-prelievo.model";

import { parametriRange } from "../../../shared/const/parametri-range.costante";
import { TrasmissioneReportNetService } from '../trasmissione-reportnet.service';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MyMatPaginatorIntl } from 'src/app/core/services/mat-paginator.service';
import { ScreenService } from 'src/app/core/services/screen.service';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { Router } from '@angular/router';

const DEFAULT_COLUMNS = [
  {
    name: 'PuntoDiCampionamento',
    label: 'Punto di campionamento'
  },
  {
    name: 'CodicePrelievo',
    label: 'Codice'
  },
  {
    name: 'DataPrelievo',
    label: 'Data'
  },
  {
    name: 'OraPrelievo',
    label: 'Ora'
  },
  {
    name: 'PrelievoOperatoDa',
    label: 'Operatore'
  },
  {
    name: 'CodiceAnalisi',
    label: 'Codice'
  },
  {
    name: 'DataAnalisi',
    label: 'Data'
  },
  {
    name: 'OraAnalisi',
    label: 'Ora'
  },
  {
    name: 'AnalisiOperateDa',
    label: 'Operatore'
  },
];
@Component({
  selector: 'app-invio-file-page',
  standalone: true,
  imports: [
    CommonModule,
    PageComponent,
    MyButtonComponent,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    MatTableModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule
  ],
  providers: [{ provide: MatPaginatorIntl, useClass: MyMatPaginatorIntl }],
  templateUrl: './invio-file-page.component.html',
  styleUrl: './invio-file-page.component.css',
  changeDetection: ChangeDetectionStrategy.Default,

})
export class InvioFilePageComponent implements AfterViewInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  isMobile = this.screen.isMobile;
  isLoading = signal(false);
  // canSend = computed(() => this.datiPrelievo().length > 0);
  canSend = computed(() => this.selectedFile() !== undefined);
  canDeleteAll = computed(() => this.datiPrelievo().length > 0);
  selectedFile: WritableSignal<any> = signal(undefined);
  datiPrelievo: WritableSignal<DatiPrelievo[]> = signal([]);
  dataSource: MatTableDataSource<DatiPrelievo>;
  displayedColumns = DEFAULT_COLUMNS;
  dragging = signal(false);
  public columnsProps: string[] = this.displayedColumns.map((column: any) => column.name);
  @ViewChild('fileInput') fileInput: ElementRef | undefined;
  isCheckingElaborazione = signal(false);
  constructor(
    private router:Router,
    private dialogService: DialogService,
    private readonly trasmissioneReportNetService: TrasmissioneReportNetService,
    private readonly screen: ScreenService,
  ) {
    this.dataSource = new MatTableDataSource(this.datiPrelievo());
    effect(() => {
      this.dataSource.data = this.datiPrelievo();
      this.dataSource.paginator = this.paginator;
    })
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

   resetForm() {
    this.selectedFile.set(undefined);
    this.datiPrelievo.set([]);
    this.displayedColumns = DEFAULT_COLUMNS;
    this.columnsProps = this.displayedColumns.map((column: any) => column.name);
    if(this.fileInput){
      this.fileInput.nativeElement.value = '';
   }
  
  }

  onDeleteAllClick() {
    if (this.canDeleteAll() === true) {
      this.dialogService.confirm('Elimina TUTTI', `I dati presenti saranno eliminati senza possibilità di recupero.`, {
        label: 'Elimina',
        color: 'warn',
        icon: 'delete',
        raised: true
      }).subscribe((result) => {
        if (result === true) {
          this.resetForm();
        }
      })
    }
  }

  onSendClick() {
    if (this.canSend() === true) {
      this.dialogService.confirm('Trasmetti', `Stai per trasmettere questo file. I dati saranno storicizzati sui server di AnTeA.`, {
        label: 'Conferma',
        color: 'primary',
        icon: 'done',
        raised: true
      }).subscribe((result) => {
        if (result === true) {
          const reader = new FileReader();
          reader.readAsDataURL(this.selectedFile());
          reader.onload = async () => {
            const base64: any = reader.result?.toString().split(',')[1]
            const filePayload = {
              name: this.selectedFile().name,
              type: this.selectedFile().type,
              base64: base64,
            }
            this.trasmissioneReportNetService.sendFile(filePayload).subscribe((value) => {
              //this.dialogService.success('Il file è stato trasmesso ai server di AnTeA.', true);
              console.log(value)
              if(!value.error){
                    this.isCheckingElaborazione.set(true);
                    this.startCheckingSaving(value.idElaborazione)
                 
              }
              this.resetForm();
            })
          };
        }
      })
    }
  }
  startCheckingSaving (idElaborazione:string) {
    const intervalID = setInterval(() => {
      this.trasmissioneReportNetService.checkElaborazioneFile(idElaborazione).subscribe((checkControllo:any) => {
        console.log(checkControllo)
        if (checkControllo?.error) {
          this.dialogService.messageDownload('error','',`errore nel salvataggio del file sui server di AnTeA.`, false );
          clearInterval(intervalID); // Chiudi l'intervallo
          this.isCheckingElaborazione.set(false);
          this.resetForm();
     
        }
        if(checkControllo?.statoElaborazione.trim()=='ERRORE') {
          this.dialogService.messageDownload('error','',`errore nel salvataggio del file sui server di AnTeA: ${checkControllo?.note}.`, false );
          clearInterval(intervalID); // Chiudi l'intervallo
          this.isCheckingElaborazione.set(false);
          this.resetForm();
      
        }
        if (checkControllo?.statoElaborazione=='ELABORAZIONE_CONCLUSA') {
          this.dialogService.success('Il file è stato elaborato e i dati sono stati salvati con successo sul database.', false);
          clearInterval(intervalID); // Chiudi l'intervallo
          this.isCheckingElaborazione.set(false);
          this.resetForm();
          this.router.navigate(['trasmissione-reportnet/lista-page']);
        }
      });

    }, 5000); // 5000 millisecondi = 5 secondi
  }
  onFileSelected(event: any) {
    this.selectedFile.set(event.target.files[0] ?? null);
    if(this.selectedFile()) {
      // this.caricaDatiExcell(event)
    }
  }
  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.dragging.set(true);
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.dragging.set(false);
  }

  onFileDrop(event: DragEvent) {
    event.preventDefault();
    this.dragging.set(false);
    if (event.dataTransfer?.files.length) {
      this.onFileSelected({ target: { files: event.dataTransfer.files } });
    }
  }
  caricaDatiExcell(evt: any) {
    this.isLoading.set(true);
    const excelWorker = new Worker(new URL('./excel-web-worker.worker', import.meta.url));
    const target: DataTransfer = <DataTransfer>(evt.target);

    if (target.files.length !== 1) throw new Error('Si stanno cercando di leggere File Multipli');
    const reader: FileReader = new FileReader();

    reader.onload = (e: any) => {
      const bstr: string = e.target.result;
      if (typeof Worker !== undefined) {
        excelWorker.onmessage = (workerEvent) => {
          this.datiPrelievo.set(workerEvent.data);
          this.displayedColumns.push(...this.getDynamicKeys(this.datiPrelievo()[0]));
          this.columnsProps = this.displayedColumns.map((column: any) => column.name);
          this.isLoading.set(false);
        };
      }
      // Invia il messaggio al Worker
      excelWorker.postMessage({ bstr });
    };
    reader.readAsBinaryString(target.files[0]);
  }

  getDynamicKeys(obj: any) {
    let columns = Object.keys(obj).filter(key => (key.startsWith('P') && key.length<=4));
    return columns.map(value => {
      return {
        name: value,
        label: value.toUpperCase()
      }
    });
  }

  transform(excelDate: number): Date {
    const excelEpoch = new Date('1899-12-30');
    const millisecondsPerDay = 24 * 60 * 60 * 1000;
    const dateValue = excelEpoch.getTime() + excelDate * millisecondsPerDay;

    return new Date(dateValue);
  }

  isOutOfRange(value: number | string, paramName: string): boolean {
    if (paramName.startsWith('P') && paramName.length <= 4) {
      const range = parametriRange[paramName];
      if (typeof value === 'number' && value!=0) {
        return value < range.min || value > range.max;
      }
    }
    return false;
  }

  isCloseToLimit(value: number | string, paramName: string): boolean {
    if (paramName.startsWith('P') && paramName.length <= 4) {
      const range = parametriRange[paramName];
      if (typeof value === 'number' && value!=0) {
        const rangeDiff = range.max - range.min;
        const threshold = 0.05 * rangeDiff;
        return value <= range.min + threshold || value >= range.max - threshold;
      }
    }
    return false;
  }

  getRowClass(data: any): string {
    const hasRed = this.getDynamicKeys(data).some(key => this.isOutOfRange(data[key.name], key.name));
    const hasYellow = this.getDynamicKeys(data).some(key => this.isCloseToLimit(data[key.name], key.name));

    if (hasRed) {
      return 'red';
    } else if (hasYellow) {
      return 'yellow';
    } else {
      return '';
    }
  }

}
